import { createUseStyles } from 'react-jss'

export const style = {
  wrapper: {
    composes: 'flex-row',
    marginBottom: 24
  },
  dropdownContainer: {
    flex: '0 0 25%'
  },
  filterContainer: {
    composes: 'flex-row',
    flex: '0 0 40%',
    marginLeft: 20
  },
  filterCategory: {
    flex: '0 0 55%'
  },
  filterCategoryValue: {
    flex: '0 0 45%',
    marginLeft: 15
  },
  sideBySideChartContainer: {
    '& > *:first-child': {
      transform: 'translateX(-16px)'
    },
    '& > *:last-child': {
      transform: 'translateX(-4px)'
    }
  },
  sideBySideChartFilterBar: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: -12,
    marginBottom: 4,
    '& .split-chart-filter-bar-element': {
      width: '50%',
      maxWidth: 476,
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      '&:first-child': {
        left: 8
      },
      '&:last-child': {
        left: -4
      }
    }
  },
  sideBySideControlBarTotal: {
    margin: '8px 0'
  }
}

export const useStyles = createUseStyles(style)
